module.exports = __webpack_public_path__ + "img/Cc-zero.795b2df4.svg";